import { get } from './P3Api';

class CategoryGroupCommodityApi {
  static async getCategoryGroupCommodities(categoryId, groupId) {
    return get(`categories/${categoryId}/groups/${groupId}/commodities`);
  }
}

export default CategoryGroupCommodityApi;
